import React, { useEffect, useState } from 'react';
import _ from 'lodash';
import moment from 'moment';
import { LibraryRendererComponent } from '../../../../../../common/components/library-renderer.component';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import MediaInfoComponent from '../../../../../../common/components/common/media-info.component';
import TabContainer from '../../../../../../common/components/tab/containers/tab.containers';
import { TicketBasicInfoComponent } from './ticket-basic-info.components';
import TicketActivityComponent from './ticket-activity.component';
import { Menu } from '@headlessui/react';

export const TicketComponent = ({
  timelines,
  ticketStatus,
  selectedTicket,
  onFormActivityMediaChange,
  onFormActivityItemChange,
  departments,
  employees,
  serviceRequests,
  ticketPriority,
  ticketType,
  ticketActivityType,
  selectedActivities,
  resolutionAction,
  back,
  id,
  TypeData,
  onFormChange,
  handleFormSubmit,
  accountTypesList,
  accountsList,
  cascadedAccountsList,
  selectedTicketStatus,
  handleTicketStatus,
}: any) => {
  const [value, setValue] = useState('1');
  const [anchorEl, setAnchorEl] = useState(null);
  const [statusName, setStatusName] = useState('');

  const [anchorShipmentEl, setAnchorShipmentEl] = useState(null);

  const handleChange = (event: any, newValue: any) => {
    setValue(newValue);
  };

  const handleClick = (event: any) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const getText = (htmlValue: any) => {
    return htmlValue.replace(/<[^>]+>/g, '') || '';
  };

  const getActionType = (ActionTypeId: any) => {
    switch (selectedTicket?.TicketStatusId) {
      case 10:
        return 'REFUND';
      case 20:
        return 'REPLACEMENT';
      case 30:
        return 'CANCEL';
      case 40:
        return 'NO-ACTION';
      default:
        return '';
    }
  };

  const handleStatus = (valueData: any) => {
    if (valueData === 'Close') {
      onFormChange({ value: 50, field: 'TicketStatusId' });
      setStatusName('Close');
    } else if (valueData === 'Resolve') {
      onFormChange({ value: 60, field: 'TicketStatusId' });
      setStatusName('Resolve');
    } else {
      onFormChange({ value: 20, field: 'TicketStatusId' });
      setStatusName('In Progress');
    }
    handleMenuClose();
  };

  // useEffect(() => {
  //   switch (selectedTicket?.TicketStatusId) {
  //     case 20:
  //       setStatusName('In Progress');
  //       break;
  //     case 50:
  //       setStatusName('Close');
  //       break;
  //     case 60:
  //       setStatusName('Resolve');
  //       break;
  //     default:
  //       setStatusName('In Progress');
  //   }
  // }, [selectedTicket]);

  const ticketActivityPrimaryComponent = () => {
    return (
      <>
        <div>
          {timelines?.length ? (
            <AccordionContainer
              child={
                <div className="timeline">
                  {_.map(timelines, (timeline, index) => (
                    <div key={index} className="timeline-item flex mb-4">
                      <div className="timeline-opposite-content text-gray-500 text-sm">
                        {moment(timeline?.StartTimeOnUtc).format('LLLL')}
                      </div>
                      <div className="timeline-separator flex items-center">
                        <div className="timeline-dot bg-blue-500 rounded-full w-3 h-3"></div>
                        <div className="timeline-connector h-full bg-gray-300 w-0.5 mx-2"></div>
                      </div>
                      <div className="timeline-content p-4 bg-white shadow-md rounded-lg">
                        <h6 className="font-semibold ">
                          <LibraryRendererComponent
                            cellRendererParams={{ library: ticketActivityType }}
                            value={timeline?.TicketActivityTypeId}
                          />
                        </h6>
                        <p className="pt-2">{timeline?.IsAssignedToLSP ? 'Assigned to LSP' : null}</p>
                        <p>{getText(timeline?.Description)}</p>
                        <p>{timeline?.ActionTypeId ? `Resolution Action: ${getActionType(timeline?.ActionTypeId)}` : null}</p>
                        <p>{timeline?.RefundAmount ? `Refund Amount: ${timeline?.RefundAmount}` : null}</p>
                      </div>
                    </div>
                  ))}
                </div>
              }
              expandedPanel="basicInfo"
              headerTitle="Timeline"
            />
          ) : null}
          <p className="font-semibold">Activity History</p>
          {_.map(selectedActivities, (selectedActivitiy, index) => (
            <div key={index} className="pt-4">
              <TicketActivityComponent
                itemIndex={index}
                TypeData={TypeData}
                onFormActivityMediaChange={onFormActivityMediaChange}
                onFormItemChange={onFormActivityItemChange}
                resolutionAction={resolutionAction}
                selectedActivitiy={selectedActivitiy}
                ticketActivityType={ticketActivityType}
                ticketStatus={ticketStatus}
                accountTypesList={accountTypesList}
                accountsList={cascadedAccountsList}
              />
            </div>
          ))}
        </div>
      </>
    )
  }


  const tabItems = [
    {
      id: 1,
      title: 'Ticket',
      component: <TicketBasicInfoComponent
        departments={departments}
        employees={employees}
        id={id}
        onFormChange={onFormChange}
        selectedTicket={selectedTicket}
        serviceRequests={serviceRequests}
        ticketPriority={ticketPriority}
        ticketType={ticketType}
        accountTypesList={accountTypesList}
        accountsList={accountsList}
      />,
      isVisible: true,
    },
    {
      id: 2,
      title: 'Ticket Activity',
      component: <>{ticketActivityPrimaryComponent()}</>,
      isVisible: id > 0 ? true : false,
    },
  ]

  return (
    <>
      <TabContainer tabItems={tabItems} />
      <div className="footer-wrapper bg-white shadow-md rounded-lg p-4 pb-10 mt-4 flex justify-between items-center">
        <h4 className="footer-text text-lg">
          {selectedTicket?.Id > 0 &&
            <>
              <div className='flex flex-row justify-start items-center'>
                <div className='px-2 font-medium text-gray-700'>Status:</div>
                <Menu as="div" className="relative text-left">
                  <div>
                    <Menu.Button
                      onClick={(e) => setAnchorShipmentEl(e.currentTarget)}
                      className="px-2 py-1 bg-slate-300 hover:bg-slate-400 text-gray-800 hover:text-gray-900 rounded cursor-pointer"
                      title="Ticket Status"
                    >
                      <span className='font-medium w-full py-2 text-base text-black'>{selectedTicketStatus?.Text}</span>
                    </Menu.Button>
                  </div>
                  {anchorShipmentEl && (
                    <Menu.Items className="absolute bottom-0 left-0 z-20 ms-3 my-1 bg-white border border-gray-300 rounded shadow-lg p-1 max-h-60 overflow-y-auto">
                      <div className="px-1 py-1">
                        {/* Ticket Stauts Section */}
                        {ticketStatus?.map((selectedTicketStatusValue: any, index: any) => (
                          <Menu.Item>
                            {({ active }) => (
                              <button
                                onClick={() => {
                                  handleTicketStatus(selectedTicketStatusValue)
                                  setAnchorShipmentEl(null);
                                }}
                                className={`${active ? 'bg-gray-200' : ''
                                  } group flex rounded-md items-center font-semibold w-full px-2 py-2 text-sm text-black`}
                              // title="Export Products"
                              >
                                <span className=''>{selectedTicketStatusValue?.Text}</span>
                              </button>
                            )}
                          </Menu.Item>
                        ))}
                      </div>
                    </Menu.Items>
                  )}
                </Menu>
              </div>
            </>
          }
          {/* {selectedTicket?.Id > 0 && (
            <>
              <span>Status: <button className="chip bg-gray-200 p-1 rounded" onClick={handleClick}>{statusName || 'In Progress'}</button></span>
              {anchorEl && (
                <div className="menu bg-white shadow-md rounded mt-2 absolute">
                  <button className="menu-item p-2" onClick={() => handleStatus('In Progress')}>In Progress</button>
                  <button className="menu-item p-2" onClick={() => handleStatus('Close')}>Close</button>
                  <button className="menu-item p-2" onClick={() => handleStatus('Resolve')}>Resolve</button>
                </div>
              )}
            </>
          )} */}
        </h4>
        <div>
          <button
            onClick={back}
            type='button'
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
          >
            Back
          </button>
          <button
            className="m-2 bg-blue-700 text-white rounded font-medium px-4 py-3 "
            onClick={handleFormSubmit}

            type="submit"
          >
            Save
          </button>
        </div>
      </div>
    </>
  );
};
